<template>
    <rkm-overlay>
        <rkm-layout-body title="Lista de vacina">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/imunizacao/baixa/List'

export default {
    components: { List },
}
</script>